import { SvgIcon } from "@mui/material";
import type { FC } from "react";

interface ShareIconProps {
  backgroundfill?: string; // this was named this way because of console issues
}

const ShareIcon: FC<ShareIconProps> = ({ backgroundfill, ...otherProps }) => (
  <SvgIcon width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...otherProps}>
    <path
      d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
      fill={backgroundfill ?? "#323232"}
    />
    <path
      d="M17.5 19H26.0938L21.1562 14.9062C20.9375 14.7188 20.9375 14.4062 21.0938 14.1875C21.2812 13.9688 21.5938 13.9688 21.8125 14.125L27.8125 19.0938C27.9062 19.2188 28 19.375 28 19.5C28 19.625 27.9062 19.7812 27.8125 19.875L21.8125 24.8438C21.7188 24.9062 21.5938 24.9688 21.5 24.9688C21.3438 24.9688 21.1875 24.9062 21.0938 24.7812C20.9375 24.5625 20.9375 24.25 21.1562 24.0625L26.0938 19.9688H17.5C15 19.9688 13 21.9688 13 24.4375V25.4062C13 25.7812 12.75 26 12.5 26C12.2188 26 12 25.7812 12 25.5V24.5312C12 21.4688 14.4375 19 17.5 19Z"
      fill="white"
    />
  </SvgIcon>
);

export default ShareIcon;
